<template>
    <div id="popLogin">
        <div id="loginMain">
            <div id="login-head">
                <div id="login-head-title" v-on:click="loginTabTitle">
                    {{leftLogin}}
                </div>
                <div id="login-close" v-on:click="closePop"></div>
            </div>
            <div id="login-content">
                <div id="fastLogin"  v-on:click="loginTabTitle">
                    {{rightLogin}}
                </div>
                <div class="loginWin">
                    <div v-if="loginTabNum == 1">
                        <!-- 用户名 -->
                        <input class="loginInput longInput" type="text" v-model="userName" maxlength="40"
                               placeholder="用户名/手机号/邮箱" v-on:blur="checkUserName">
                        <p class="errTip" v-if="nameErr">{{nameErrTip}}</p>
                        <!-- 密码 -->
                        <div class="passBox">
                            <input class="loginInput longInput" type="password" maxlength="16" v-model="password"
                                   placeholder="密码"
                                   v-if="passType" v-on:blur="checkPassword">
                            <input class="loginInput longInput" type="text" v-model="password" maxlength="16" placeholder="密码"
                                   v-if="!passType" v-on:blur="checkPassword">
                            <img class="passEye" src="./images/open.png" alt="" v-if="passType"
                                 v-on:click="changePassType">
                            <img class="passEye" src="./images/close.png" alt="" v-if="!passType"
                                 v-on:click="changePassType">
                        </div>
                        <p class="errTip" v-if="passErr">{{passErrTip}}</p>

                        <!-- 图片验证码 4位 -->
                        <input class="loginInput midInput" type="text" v-model="imgCode" placeholder="验证码" maxlength="4"
                               v-on:blur="checkCode">
                        <img class="codeImg" v-bind:src="imgSrc" alt="" v-on:click="changImgSrc">
                        <p class="errTip" v-if="imgCodeErr">{{imgCodeErrTip}}</p>
                        <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
                        <input class="longInput confirm" type="button" value="登录" v-on:click="passLogin">
                    </div>
                    <div v-else>
                        <!-- 手机号 -->
                        <input class="loginInput longInput" type="text" v-model="phone" maxlength="11" placeholder="手机号"
                               v-on:blur="checkFastPhone">
                        <p class="errTip" v-if="phoneErr">{{phoneErrTip}}</p>
                        <!-- 短信验证码 6位 -->
                        <input class="loginInput midInput" type="text" v-model="phoneCode" placeholder="短信验证码"
                               v-on:blur="checkPhoneCode" maxlength="6">
                        <input type="button" class="codeImg getPhoneCode" v-bind:value="codeTime" v-on:click="getPhoneCode" v-on:blur="clearTips" v-bind:disabled="noSend">
                        <p class="errTip" v-if="phoneCodeErr">{{phoneCodeErrTip}}</p>
                        <!-- 短信登录按钮 -->
                        <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
                        <p class="errTip msgErrTip" v-if="msgErr">{{msgErrTip}}</p>
                        <input class="longInput confirm" type="button" value="登录" v-on:click="phoneLogin">
                    </div>
                    <!-- 密码登录按钮 -->

                    <div class="loginBottom">
                        <a href="http://newsso.forex.com.cn/#/findPassword" target="view_window">忘记密码？</a>
                    </div>
                    <div class="loginRegister">
                        <span>还没有帐号？&nbsp;&nbsp;&nbsp;&nbsp;</span><a href="http://newsso.forex.com.cn/#/register" target="view_window">立即注册</a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    #popLogin{
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.50);
        position:fixed;
        z-index:1002;
        top:0;
        left:0;
        #loginMain{
            margin: 0 auto;
            margin-top: 150px;
            width: 436px;
            border-radius: 10px;
            height: 100px;
            #login-head{
                height: 46px;
                margin: 0 auto;
                width: 100%;
                border-radius: 10px 10px 0 0;
                background: #f5f5f5;
                #login-head-title{
                    float: left;
                    font-size: 18px;
                    height: 25px;
                    margin-left: 58px;
                    margin-top: 14px;
                    cursor:pointer;
                }
                #login-close{
                    width: 9.2px;
                    height: 9.2px;
                    float: left;
                    background: url("images/closeLogin.png");
                    background-size: 100% 100%;
                    margin-left: 280px;
                    margin-top: 20.4px;
                    cursor: pointer;
                }
            }
            #login-content{
                width: 100%;
                background:#ffffff;
                border-radius: 0px 0px 10px 10px;
                #fastLogin{
                    font-size: 14px;
                    color: #666666;
                    display: inline-block;
                    height: 20px;
                    margin-left: 322px;
                    margin-top: 9px;
                    cursor:pointer;
                }
                .loginWin {
                    width: 320px;
                    margin: 0 auto;
                    margin-top: 26px;
                    .loginInput {
                        width: 320px;
                        height: 42px;
                        background-color: #fff;
                        border: none;
                        border-radius: 6px;
                        padding-left: 10px;
                        font-size: 16px;
                        padding: 10px 8px;
                        color: #666;
                        margin-top: 12px;
                        margin-bottom: 7px;
                        border: 1px solid #dadada;
                    }
                    .midInput {
                        width: 180px;
                        border: 1px solid #dadada;
                    }
                    .passBox {
                        position: relative;
                        .passEye {
                            position: absolute;
                            width: 17px;
                            height: 17px;
                            right: 22px;
                            top: 24.5px;
                            cursor: pointer;
                        }
                    }
                    .codeImg {
                        width: 120px;
                        height: 42px;
                        float: right;
                        margin-top: 12px;
                        border-radius: 6px;
                        cursor: pointer;
                        border: 1px solid #dadada;
                        &.getPhoneCode {
                            display: inline-block;
                            border: none;
                            background-color: #364983;
                            font-size: 12px;
                            color: #fff;
                            text-align: center;
                        }
                    }
                    .confirm{
                        background-color: #364983;
                        color:#fff;
                        width: 320px;
                        font-size:18px;
                        cursor:pointer;
                        margin-top:12px;
                        border-radius: 6px;
                        line-height: 42px;
                        border: 0px;
                        &:hover{
                            background: #435898;
                        }
                    }
                    .errTip{
                        font-size:12px;
                        line-height:18px;
                        color:#CE2E2E;
                        padding-left:10px;
                        &.msgErrTip{
                            line-height:22px;
                        }
                    }
                    .loginBottom{
                        height:18px;
                        margin-top:9px;
                        cursor:pointer;
                        a{
                            font-size:14px;
                            color:#666666;
                            line-height:20px;
                            float:right;
                            &:hover{
                                color:#364983;
                            }
                        }
                    }
                    .loginRegister{
                        margin-top: 23px;
                        text-align: center;
                        padding-top: 10px;
                        padding-bottom: 18px;
                        span{
                            font-size: 14px;
                            color: #666666;
                        }
                        a{
                            color:#364983;
                            margin-top: 10px;
                            font-size: 18px;
                            &:hover{
                                color: #435898;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
<script>
    import api from 'sso.server';
    import reg from 'reg';
    import aes from 'AES';

    module.exports = Vue.component("pop-login", {
        data:function(){
			return {
                leftLogin:"密码登录",    // 左边显示的文本
                rightLogin:"快速登录",    // 右边显示的文本
                passType:true,          // 密码类型切换
                loginTabNum:1,
                userName:'',            // 用户名
                nameErr:false,          // 用户名错误
                nameErrTip:null,

                password:'',            // 密码
                passErr:false,          // 密码错误
                passErrTip:null,

                phone:'',               // 手机号
                phoneCode:'',           // 短信验证码
                phoneErr:false,         // 手机号错误
                phoneErrTip:null,
                phoneCodeErr:false,
                phoneCodeErrTip:null,   // 短信验证码

                imgCode:'',             // 验证码
                imgCodeErr:false,       // 验证码错误
                imgCodeErrTip:null,
                imgSrc:window.PAGE_DATA.commonData.newssoPath + window.PAGE_DATA.commonData.imgSrc, // 验证码图片地址

                codeTime:'发送验证码',
                msgErr:false,           // 后台错误提示
                msgErrTip:null,
                noSend:false,           // 禁止发送验证

                appKey:"",
                url : "",

			}
		},
		props:{


		},
		mounted:function(){
		    let firstSplit = location.href.split("?")[1];
            if (firstSplit !== undefined) {
                let secSplit = firstSplit.split("#")[0];
                let arr = secSplit.split("&");
                this.appKey = arr[0].split("=")[1];
                this.url = arr[1].split("=")[1];
            }
		},
		methods:{
		     // 密码登录和快速登录切换
            loginTabTitle:function(){
                if (this.leftLogin == "密码登录") {
                    this.leftLogin = "快速登录";
                    this.rightLogin = "密码登录";
                    this.loginTabNum = 2;
                } else {
                    this.leftLogin = "密码登录";
                    this.rightLogin = "快速登录";
                    this.loginTabNum = 1;
                }
                this.clearTips();
                this.userName = "";
                this.password = "";
                this.phone = "";
                this.phoneCode = "";
            },
            // 检测用户名,失去焦点时不能为空
            checkUserName:function(){
                if (!this.userName) {
                    this.nameErr = true;
                    this.nameErrTip = "用户名不能为空";
                } else {
                    this.nameErr = false;
                    this.nameErrTip = "";
                }
                this.msgErr = false;
            },
            // 密码失去焦点的时候,判断一下是否为空,格式是否符合
            checkPassword:function(){
                if (!this.password) {
                    this.passErr = true;
                    this.passErrTip = "密码不能为空";
                } else if (!reg.validPassword(this.password)) {
                    this.passErr = true;
                    this.passErrTip = "密码格式错误";
                } else {
                    this.passErr = false;
                    this.passErrTip = "";
                }
                this.msgErr = false;
            },
            // 验证码失去焦点的时候,是否符合规范
            checkCode:function(){
                if (!this.imgCode) {
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = "验证码不能为空";
                } else if (!reg.validVerificationCode(this.imgCode)) {
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = "验证码格式有误";
                } else {
                    this.imgCodeErr = false;
                    this.imgCodeErrTip = "";
                }
                this.msgErr = false;
            },
            // 密码显示隐藏切换
            changePassType:function(){
                this.passType = !this.passType;
            },
            // 更新图片验证码
            changImgSrc:function(){
                this.imgSrc = null;
                this.imgSrc = window.PAGE_DATA.commonData.newssoPath + window.PAGE_DATA.commonData.imgSrc + "?" + new
                Date().getTime();
            },
            // 快读登录时,验证码失去焦点的时候对验证码进行简单的校验
            checkPhoneCode:function(){
                if (this.phoneCode.length == 0) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码不能为空";
                    this.fastPhoneCode = false;
                } else if (!reg.phoneCode(this.phoneCode)) {
                    this.phoneCodeErr = true;
                    this.phoneCodeErrTip = "短信验证码格式不正确";
                    this.fastPhoneCode = false;
                } else {
                    this.phoneCodeErr = false;
                    this.phoneCodeErrTip = "";
                    this.fastPhoneCode = true;
                }
                this.msgErr = false;
            },
            // 快速登录的时候检测手机号
            checkFastPhone:function(){
                if (this.phone.length == 0) {
                    this.phoneErr = true;
                    this.phoneErrTip = "手机号不能为空";
                } else if(!reg.validPhone(this.phone)){
                    this.phoneErr = true;
                    this.phoneErrTip = '手机号不符合规范';
                } else {
                    let _this = this;
                    let getPhone = {
                        phone: this.phone
                    }
                    api.checkPhoneFast(getPhone)
                    .then(function(res){
                        if(res.data.header && (res.data.header.code == 200)){
                            _this.checkPhoneFast = true;
                            _this.phoneErr = true;
                            _this.phoneErrTip = "";
                        }else{
                            _this.phoneErr = true;
                            _this.phoneErrTip = res.data.header.msg;
                            _this.checkPhoneFast = false;
                        }
                    },function(res){
                        _this.phoneErr = true;
                        _this.phoneErrTip = "网络异常";
                        _this.checkPhoneFast = false;
                    })
                }
            },
              // 快速登录按钮触发点击提交
            phoneLogin:function(){
                let _this = this;
                if (!this.phoneErr && !this.phoneCodeErr) {
                    if (this.phone.length == 0) {
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不能为空';
                        this.msgErr = false;
                    } else if (this.phoneCode.length == 0) {
                        this.phoneCodeErr = true;
                        this.phoneCodeErrTip = '手机验证码不能为空';
                        this.msgErr = false;
                    } else {
                        _this.clearTips();
                        _this.noLogin = true;
                        let timer = parseInt((new Date().getTime()) / 1000);
                        let param = {
                            timer : timer,
                            valdaiteCode: _this.phoneCode,
                            phone:aes.getAes(_this.phone, timer),
                            url:_this.url,
                            appKey:_this.appKey
                        }
                        api.phoneFastLogin(param)
                        .then(function(res){
                            if ((res.data.header && (res.data.header.code == 200)) == 1) {
                                location.reload(location.href);
                            } else {
                                _this.msgErr = true;
                                _this.msgErrTip = res.data.header.msg;
                                _this.imgSrc = window.PAGE_DATA.commonData.newssoPath + window.PAGE_DATA.commonData.imgSrc +
                            "?" + new Date().getTime();
                            }
                        }, function(res){

                        })
                    }

                }
            },
             // 密码登录
            passLogin:function(){
                if(this.userName.length == 0){
                    this.nameErr = true;
                    this.nameErrTip = '用户名不能为空';
                    this.msgErr = false;
                }else if(this.password.length == 0){
                    this.passErr = true;
                    this.passErrTip = '密码不能为空';
                    this.msgErr = false;
                }else if (this.passErr) {
                    this.msgErr = false;
                    return;
                } else if(this.imgCode.length == 0){
                    this.imgCodeErr = true;
                    this.imgCodeErrTip = '验证码不能为空';
                    this.msgErr = false;
                } else if(this.imgCodeErr){
                    this.msgErr = false;
                    return;
                } else {
                    let _this = this;
                    let timer = parseInt((new Date().getTime()) / 1000);
                    _this.clearTips();
                    // aes对用户名密码加密
                    let aesUserName = aes.getAes(this.userName, timer);
                    let aesPassWord = aes.getAes(this.password, timer);
                    let param = {
                        username:aesUserName,
                        password:aesPassWord,
                        url:this.url,
                        appKey:this.appKey,
                        timer:timer,
                        valdaiteCode:this.imgCode
                    }
                    api.passLogin(param)
                    .then(function(res){
                        if ((res.data.header && (res.data.header.code == 200)) == 1) {
                            location.reload(location.href);
                        } else {
                            _this.msgErr = true;
                            _this.msgErrTip = res.data.header.msg;
                            _this.imgSrc = window.PAGE_DATA.commonData.newssoPath + window.PAGE_DATA.commonData.imgSrc +
                        "?" + new Date().getTime();
                        }
                    },function(res){
                        _this.msgErr = true;
                        _this.msgErrTip = res.data.header.msg;
                        _this.imgSrc = window.PAGE_DATA.commonData.newssoPath + window.PAGE_DATA.commonData.imgSrc +
                        "?" + new Date().getTime();
                    })
                }
            },
             // 获取短信验证码
            getPhoneCode:function(){
                let _this = this;
                if(!_this.phoneErr){
                    if (this.phone.length == 0) {
                        this.phoneErr = true;
                        this.phoneErrTip = "手机号不能为空";
                    } else if(!reg.validPhone(this.phone)){
                        this.phoneErr = true;
                        this.phoneErrTip = '手机号不符合规范';
                    } else {
                        _this.noSend = true;
                        let param = {
                            phone:_this.phone
                        }
                        api.getPhoneCodeFastLogin(param)
                        .then(function(res){
                            if ((res.data.header && (res.data.header.code == 200)) == 1) {
                                _this.codeTime = 60;
                                _this.noSend = true;
                                _this.phoneCodeErrTip = "";
                                let timer = setInterval(function(){
                                    if(_this.codeTime != 0){
                                        _this.codeTime--;
                                    }else{
                                        clearInterval(timer);
                                        _this.codeTime = '重新发送';
                                        _this.noSend = false;       // 倒计时结束，放开获取验证码按钮
                                    }
                                },1000)
                            } else {
                                _this.phoneCodeErr = true;
                                _this.phoneCodeErrTip = res.data.header.msg;
                            }
                        },function(res){

                        })
                    }

                }
            },
            clearTips:function(){
                this.nameErr = false;
                this.phoneErr = false;
                this.phoneCodeErr = false;
                this.msgErr = false;
                this.passErr = false;
            },
			closePop:function(){
				this.$emit('popClose');      // 取消或关闭按钮回调
			},
			onOk:function(){
				this.$emit('popConfirm');    // 确认按钮回调
			},
			onCancle:function(){
				this.closePop();
			}
		}
    })
</script>



// WEBPACK FOOTER //
// src/components/common/popLogin/popLogin.vue